import { Box, useMediaQuery } from "@mui/material";
import { Filter, Search } from "pepsico-ds";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setFritoCountry,
  setFritoLanguage,
  setFritoSearch,
  setFritoSector,
  setFritoSubject,
} from "../../slices/fritoForumPageSlice";
import { handleSectorSelection } from "../../utils/function";

function ForumFilter({ handleSearch }) {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const dispatch = useDispatch();
  const isDarkTheme = useSelector((state) => state.theme);
  const {
    sectorFilter,
    countryFilter,
    laguageFilter,
    subjectFilter,
    sectorAndCountry,
  } = useSelector((store) => store.internalFilter);

  const [countries, setCountries] = useState(countryFilter);
  const [localSector, setLocalSector] = useState(null);

  const renderFilter = (label, onChange, options) => (
    <Filter
      label={
        <span style={{ fontFamily: "Inter", fontSize: "14px" }}>{label}</span>
      }
      onChange={onChange}
      options={(options || []).map((item) => ({
        id: item.id,
        label: item.name,
      }))}
      selection="single"
      size="medium"
      isDark={isDarkTheme}
    />
  );

  const handleSectorChange = (sector) => {
    handleSectorSelection(
      sector,
      localSector,
      setLocalSector,
      dispatch,
      setCountries,
      countryFilter,
      sectorAndCountry,
      setFritoSector
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "24px" : 0,
        justifyContent: isMobile ? "flex-start" : "space-between",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          {renderFilter("Sector", handleSectorChange, sectorFilter)}
          {renderFilter(
            "Country",
            (val) => dispatch(setFritoCountry(val)),
            countries
          )}
          {renderFilter(
            "Language",
            (val) => dispatch(setFritoLanguage(val)),
            laguageFilter
          )}
          {renderFilter(
            "Subject",
            (val) => dispatch(setFritoSubject(val)),
            subjectFilter
          )}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "row" : " ",
          justifyContent: isMobile ? "space-between" : "flex-start",
          gap: isMobile ? 0 : "16px",
        }}
      >
        <Search
          onUpdate={(val) => handleSearch(val)}
          isDark={isDarkTheme}
          className={isMobile ? "w-full !max-w-full" : ""}
        />
      </Box>
    </Box>
  );
}

export default ForumFilter;
